/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { ElementRef } from "@angular/core";
import { types } from "mediasoup-client";

const returnProducerVideoEle = (): HTMLVideoElement => {
  return document.querySelector("#user-video");
};

const returnProducerAudioEle = (): HTMLVideoElement => {
  return document.querySelector("#user-audio");
};

const setMediaEle = async (
  stream: MediaStream,
  mediaElement: HTMLVideoElement | HTMLAudioElement
) => {
  mediaElement.srcObject = stream;
  mediaElement.muted = true;
  mediaElement.autoplay = true;
};

const createOrUpdateStreamAndAddTrack = (
  mediaType: types.Consumer | types.Producer,
  stream: MediaStream
) => {
  if (!stream) stream = new MediaStream();
  stream.addTrack(mediaType.track);
  return stream;
};

const stopStream = (
  stream: MediaStream | null,
  videoEl?: ElementRef<HTMLVideoElement>
) => {
  if (!stream) return;

  if (videoEl && videoEl.nativeElement) {
    videoEl.nativeElement.srcObject = null;
  }

  stream.getTracks().forEach((track) => {
    stream.removeTrack(track);
    track.stop();
  });
};

export {
  returnProducerVideoEle,
  setMediaEle,
  createOrUpdateStreamAndAddTrack,
  returnProducerAudioEle,
  stopStream,
};
